import { differenceInDays } from 'date-fns';

/** 積日・降日 180日制限（積地 start_at 最小 〜 降地 end_at 最大で 180日以内） */
export const LOADING_UNLOADING_DATE_RANGE_DAYS = 180;

export const LOADING_UNLOADING_DATE_RANGE_ERROR_MESSAGE =
  '積日と降日の間隔は180日以内で指定してください';

/**
 * 積日・降日の間隔が180日以内か検証する。
 * @returns 180日以内なら true、超えていれば false
 */
export const isValidLoadingUnloadingDateRange = (
  loadingDate: Date,
  unloadingDate: Date
): boolean => differenceInDays(unloadingDate, loadingDate) <= LOADING_UNLOADING_DATE_RANGE_DAYS;
